import { defineStore } from 'pinia'
import type { ISensorChartOverlayAlarm } from '@/interfaces/components/sensorChartAlarm'
import SensorResource from '@/api/resources/sensor'
import { fetchSensorChartOverlayAlarms } from '@/utils/sensor-chart-alarms'

export const useDoorOpenChartStore = defineStore('doorOpenChart', {
  state: () => ({
    readingsCache: {} as Record<string, unknown>,
    alarmsCache: {} as Record<string, ISensorChartOverlayAlarm[]>,
    doorOpenPeriodsCache: {} as Record<string, unknown>,
  }),
  actions: {
    async fetchReadings(sensorId: number, startDate: string, endDate: string, resolution: string) {
      const key = `${sensorId}_${startDate}_${endDate}_${resolution}`
      if (this.readingsCache[key]) {
        return this.readingsCache[key]
      }
      try {
        const res = await SensorResource.getOpenSensorReadings({
          sensorId,
          dateRange: `start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`,
          resolution,
        })
        this.readingsCache[key] = res
        return res
      } catch (error) {
        throw error
      }
    },
    async fetchAlarms(sensorId: number, startDate: string, endDate: string) {
      const key = `${sensorId}_${startDate}_${endDate}`
      if (this.alarmsCache[key]) {
        return this.alarmsCache[key]
      }
      try {
        const alarms = await fetchSensorChartOverlayAlarms({
          sensorId,
          sensorAlarmType: 'door_open',
          startDate,
          endDate,
        })
        this.alarmsCache[key] = alarms
        return this.alarmsCache[key]
      } catch (error) {
        throw error
      }
    },
    async fetchDoorOpenPeriods(sensorId: number, startDate: string, endDate: string) {
      const key = `${sensorId}_${startDate}_${endDate}`
      if (this.doorOpenPeriodsCache[key]) {
        return this.doorOpenPeriodsCache[key]
      }
      try {
        const res = await SensorResource.getDoorOpenPeriods({ sensorId, startDate, endDate })
        this.doorOpenPeriodsCache[key] = res
        return res
      } catch (error) {
        throw error
      }
    },
  },
})
